import {
    UPDATEWALLETTRANSACTIONSTATUSPARTNER_SUCCESS,
    UPDATEWALLETTRANSACTIONSTATUSPARTNER_FAILED,
    RESET_UPDATEWALLETTRANSACTIONSTATUSPARTNER,
    LOADING_UPDATEWALLETTRANSACTIONSTATUSPARTNER,
    NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSPARTNER,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {

    switch (action.type) {
        case LOADING_UPDATEWALLETTRANSACTIONSTATUSPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case UPDATEWALLETTRANSACTIONSTATUSPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case UPDATEWALLETTRANSACTIONSTATUSPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_UPDATEWALLETTRANSACTIONSTATUSPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};
